<span>
  <mat-icon>{{icon}}</mat-icon>
 {{profileTypeTranslation}} à {{profile.schoolName}}
</span>
